const Joi = require('joi');

exports.buildChangePasswordSchema = ({
    usePasswordRules,
    showAgreeToTerms,
    useCurrentPassword,
    useLogoutOtherDevices
} = {}) => {

    return Joi.object({
        ...(usePasswordRules ? {
            newPassword: Joi
                .string()
                .min(8)
                .required()
                .messages({
                    'string.empty': 'New password is required',
                    'string.min': 'Minimal length of password is 8 characters',
                    'any.required': 'New password is required'
                })
        } : {
            newPassword: Joi
                .string()
                .required()
                .messages({
                    'string.empty': 'New password is required',
                    'any.required': 'New password is required'
                })
        }),
        confirmNewPassword: Joi
            .string()
            .required()
            .valid(Joi.ref('newPassword'))
            .messages({
                'string.empty': 'Password confirm is required',
                'any.required': 'Password confirm is required',
                'any.only': 'Passwords do not match'
            }),
        ...(showAgreeToTerms && {
            agreeToTerms: Joi.bool()
                .valid(true)
                .required()
                .messages({
                    'any.only': 'Please agree to terms',
                    'any.required': 'Please agree to terms'
                })
        }),
        ...(useCurrentPassword && {
            currentPassword: Joi.string()
                .required()
                .messages({
                    'string.empty': 'Current password is required',
                    'any.required': 'Current password is required'
                })
        }),
        ...(useLogoutOtherDevices && {
            logoutOtherDevices: Joi.bool().required()
        })
    }).unknown(true);
};
